import { Selection, EnterElement } from "d3"
import { D3OneToOneRenderable } from "./D3OneToOneRenderable"

export type D3RectConfig = {
    x: number
    y: number
    width: number
    height: number
    color: string
    clipPathId: string
    transitionDuration: number
    opacity: number
}

export class D3Rect extends D3OneToOneRenderable<SVGGElement, SVGRectElement, D3RectConfig> {
    protected enter = (newElements: Selection<EnterElement, D3RectConfig, any, any>): Selection<SVGRectElement, D3RectConfig, any, any> => {
        const rect = newElements.append("rect")
            .attr("class", this.className)
            .attr("clip-path", `url(#${this.config.clipPathId})`)
            
        rect.transition().duration(this.config.transitionDuration ?? 0)
            .attr("x", this.config.x)
            .attr("y", this.config.y)
            .attr("width", this.config.width)
            .attr("height", this.config.height)
            .attr("fill", this.config.color)
            .attr("opacity", this.config.opacity)

        return rect
    }

    protected update = (updatedElements: Selection<SVGRectElement, D3RectConfig, any, any>): Selection<SVGRectElement, D3RectConfig, any, any> => {
        const rect = updatedElements
            .attr("clip-path", `url(#${this.config.clipPathId})`)
            
        rect.transition().duration(this.config.transitionDuration ?? 0)
            .attr("x", this.config.x)
            .attr("y", this.config.y)
            .attr("width", this.config.width)
            .attr("height", this.config.height)
            .attr("fill", this.config.color)
            .attr("opacity", this.config.opacity)

        return rect
    }

    protected exit(exitedElements: Selection<any, any, SVGGElement, D3RectConfig>): void {
        exitedElements.transition()
            .duration(this.config.transitionDuration ?? 0)
            .attr("x", this.config.x)
            .attr("width", 0)
            .attr("opacity", 0)
            .remove()
    }
}
